import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { IPurchaseAddEditRequest } from '../../../../model/scp/purchase/request/purchase-add-edit-request';
import { Box, Button, Grid, IconButton, InputLabel, LinearProgress, MenuItem, OutlinedInput, Select, Tooltip } from '@mui/material';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { IFileResponse } from '../../../../model/scp/base/response/file-response';
import DefaultUploadFile from '../../../../components/default-upload-file';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { DefaultDialogProps } from '../../../../components/default-dialog';
import PreviewIcon from '@mui/icons-material/Preview';
import { dataGridLocaleConfig } from '../../../../config/data-grid-locale';
import { usePurchaseFileController } from './controllers/purchase-file-controller';

export interface IPurchaseFileDataTableProps {
    purchaseRequest: IPurchaseAddEditRequest,
    purchaseId?: string | undefined
};

export default function PurchaseFileDataTable({ props }: { props: IPurchaseFileDataTableProps }) {
    const controller = usePurchaseFileController(props.purchaseId);

    const {
        filePurchaseRequest,
        purchaseFilesResponse,
        loadMoreData,
        error,
        typeDocument,
        handleOnChange,
        saveFile,
        deleteFile,
        setFileUpload,
        handlePageChange,
        showDialog } = controller;

    const columns: GridColDef<IFileResponse>[] = [
        {
            field: 'number',
            headerName: 'Nº',
            minWidth: 80, sortable: false,
            disableColumnMenu: true,
            align: 'right',
            headerAlign: 'right'
        },

        {
            field: 'title',
            headerName: 'Titulo',
            minWidth: 280, sortable: false,
            disableColumnMenu: true
        },
        {
            field: 'documentTypeDescription',
            headerName: 'Tipo',
            minWidth: 160, sortable: false,
            disableColumnMenu: true,
        }
        ,
        {
            field: 'actions',
            type: 'actions',
            headerName: '',
            width: 100,
            renderCell: (params) => {

                return [
                    <Tooltip title="Visualizar Arquivo">
                        <IconButton aria-label="Editar" onClick={async () => {

                            window.open(params.row.fileUrl, '_blank');
                        }}>
                            <PreviewIcon />
                        </IconButton>
                    </Tooltip>,
                    <Tooltip title="Excluir">
                        <IconButton aria-label="Excluir" onClick={() => {
                            showDialog({
                                title: 'Pergunta', message: 'Deseja realmente excluir a anexo? Caso deseje excluir preencha a justificativa abaixo:', onYesClick: (justification: string) => {
                                    if (params.row.number !== undefined) {
                                        deleteFile(params.row.number, justification);
                                    }
                                }, inputProps: {
                                    rows: 4
                                }
                            } as DefaultDialogProps);
                        }}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip >
                ];
            }
        }
    ];


    return (
        <React.Fragment>
            <Box sx={{ textAlign: 'right' }}>
                <Grid container spacing={2}
                    sx={{ mt: '10px', mb: '10px', pr: '10px', textAlign: 'left' }} >
                    <Grid item lg={2}
                        sm={2}
                        xl={2}
                    >
                        <InputLabel>Tipo de Arquivo</InputLabel>
                        <Select
                            onChange={handleOnChange}
                            onBlur={handleOnChange}
                            fullWidth
                            error={filePurchaseRequest.documentTypeId === undefined && error ? true : false}
                            value={filePurchaseRequest.documentTypeId ? filePurchaseRequest.documentTypeId : ''}
                            name='select-document-type-atachment'
                        >
                            <MenuItem value={undefined}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {typeDocument.map((element) => {
                                return (
                                    <MenuItem value={element.id} key={element.id}>{element.name}</MenuItem>
                                );
                            })}
                        </Select>
                    </Grid>
                    <Grid
                        item
                        lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Titulo do Documento</InputLabel>
                        <OutlinedInput
                            name="input-title-atachment"
                            error={(filePurchaseRequest.title === undefined || filePurchaseRequest.title.length === 0) && error ? true : false}
                            value={filePurchaseRequest.title ? filePurchaseRequest.title : ''}
                            fullWidth
                            onChange={handleOnChange}
                            onBlur={handleOnChange}
                        />
                    </Grid>
                    <Grid item lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Tipo de Documento (pdf). Tamanho Max: 30mb </InputLabel>
                        <DefaultUploadFile props={{
                            id: "file-upload-atachment",
                            setFileUpload: setFileUpload,
                            file: filePurchaseRequest.document, extensions: ["pdf"], maxFileSizeMb: 30, error: (filePurchaseRequest.document === undefined || filePurchaseRequest.document === null) && error ? true : false
                        }}></DefaultUploadFile>
                    </Grid>

                    <Grid item lg={2}
                        sm={2}
                        xl={2}>
                        <InputLabel> &nbsp; </InputLabel>
                        <Button variant="contained" fullWidth component="label" size="large" sx={{ height: '55px' }} startIcon={<PlaylistAddIcon />}
                            onClick={() => {
                                if (props.purchaseId !== undefined && props.purchaseId !== null) {
                                    saveFile();
                                }

                            }}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <DataGrid
                columns={columns}
                disableSelectionOnClick
                onPageChange={handlePageChange}
                paginationMode="server"
                components={{
                    LoadingOverlay: LinearProgress,
                }}
                loading={loadMoreData}
                rowsPerPageOptions={[purchaseFilesResponse.pageSize]}
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },

                }}
                rowCount={purchaseFilesResponse.totalRecords}
                rows={purchaseFilesResponse.items}
                pagination={undefined}
                getRowId={(row: any) => row.number}
                localeText={dataGridLocaleConfig}
            />
        </React.Fragment>
    )
}